import { useAppSelector } from "../../redux/hooks";
import { selectOwnDatatypes } from "../../redux/treeSlice";
import type { TreeNodeType } from "../../types/ProfilierungHome";

export default function useDataTypes(standard?: string): TreeNodeType[] | null {
	const data = useAppSelector(selectOwnDatatypes(standard));
	return data;
}
